module.exports = __webpack_public_path__ + "img/third3.a54f193d.svg";